import React from 'react';
import { Layout } from 'antd';

const { Footer: AntdFooter } = Layout;

export const Footer: React.FC = () => {
  return (
    <AntdFooter className="admin-footer">
      ©{new Date().getFullYear()} Created by DYENites for DYEN
    </AntdFooter>
  );
};